export const CompanyName = 'Lady Cinder';
export const DirectorName = 'Lady Cinder';
export const CompanyTagLine = 'More than a goddess…I am divinity realized.';
export const MainTitle = 'The Reign of a Relentless Queen';
export const ServiceArea = 'Worldwide & Touring';
export const SubtitleMain = 'Unyielding Dominance, Hypnosis, and Complete Control';
export const SubtitleSecondary = 'Eyes ever watching. Enter my world of hypnosis, sensual sadism, and mind play.';

// Contact / Online Presence
export const CompanyPhoneNumber = '8183361909'; // optional, leave blank
export const CompanyEmailAddress = 'Ladycinder1110@gmail.com'; // optional, leave blank

export const LocationCity = 'Los Angeles';
export const LocationCountry = 'United States';

// Address Constants (kept blank)
export const AddressLine1 = '';
export const AddressLine2 = '';
export const AddressLine3 = '';
export const AddressLine4 = '';
export const PostalCode = '';

// Socials

// Keywords (SEO)
export const KeywordsPages =
  'Lady Cinder, dominatrix, hypnosis, LA dominatrix, touring dominatrix, sensual sadism, mind play, indoctrination, propaganda play, circus sideshow, fire eater, neon gothic, magenta, violet, dungeon';
// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 60000;
export const CookiePolicyName = 'CookiePolicy';

// Business URL
export const FULL_BUSINESS_URL = 'https://www.ladycinder.com';
export const SHORT_BUSINESS_URL = 'ladycinder.com';
export const DISPLAY_BUSINESS_URL = 'www.ladycinder.com';

// Social Media URLs
export const LOYALFANS_URL = 'https://www.loyalfans.com/ladycinder';
export const TRYST_URL = 'https://tryst.link/bdsm/ladycinder1110#rates';
export const TWITTER_URL = 'https://x.com/ladycinder1110';
export const TIKTOK_URL = 'https://tiktok.com/ladycinder1110';
export const INSTAGRAM_URL = 'https://www.instagram.com/lady_cinder1110';
export const MSHA_URL = 'https://msha.ke/ladycinder';
export const THRONE_URL = 'https://throne.com/ladycinder/collections/cash-gifts';
export const FETLIFE_URL = 'https://fetlife.com';
export const CUSTOM_FORM_URL = 'https://form.jotform.com';
export const APPLE_PAY_EMAIL = 'ladycinder1110@gmail.com';
// export const ONLYFANS_URL = 'https://onlyfans.com';
// export const CASH_APP_URL = 'https://tributify.com';
// export const FANSLY_URL = 'https://fans.ly';
// export const MINTSTARS_URL = 'https://mintstars.com';
// export const CLIPS_4_SALE_URL = 'https://www.clips4sale.com';
// export const SNAPCHAT_URL = 'https://www.snapchat.com';
// export const YOUPAY_URL = 'https://youpay.me';
// export const SEXT_PANTHER_URL = 'https://www.sextpanther.com';
// export const SCATBOOK_URL = 'https://scatbook.com';
// export const FEET_FINDER_URL = 'https://app.feetfinder.com';
// export const TELEGRAM_URL = 'https://t.me';
// export const ALL_THINGS_WORN_URL = 'https://www.allthingsworn.com';
// export const REDDIT_URL = 'https://www.reddit.com';


export const FMTY_RATE = '$2000';

// Maps
export const GoogleMapsEmbedUrl = "https://www.google.com/maps/embed?pb=YOUR-EMBEDDED-MAP-URL";

// Bot Data
export const BotName = 'Jerry'
export const TRIBUTE_AMOUNT = '$50'